var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs-items',{model:{value:(_vm.selectedAppBarTab),callback:function ($$v) {_vm.selectedAppBarTab=$$v},expression:"selectedAppBarTab"}},_vm._l((_vm.tabs),function(tab){return _c('v-tab-item',{key:tab.key,attrs:{"value":tab.key}},[_c('LocationVariationMap',{attrs:{"zone":tab,"location":_vm.location}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }